import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

import type { AgeRange } from "@/types/story";

/**
 * Merge Tailwind CSS classes with clsx
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/**
 * Book Type Information
 */
export interface BookTypeInfo {
  label: string;
  shortLabel: string;
  description: string;
  ageLabel: string;
}

/**
 * Book Type Mapping
 * Maps internal age_range values to user-friendly book type labels
 */
export const BOOK_TYPES: Record<AgeRange, BookTypeInfo> = {
  "3-5": {
    label: "Picture Book",
    shortLabel: "Picture Book",
    description: "Simple stories with vibrant illustrations for young readers",
    ageLabel: "Ages 3-5",
  },
  "5-8": {
    label: "Easy Reader",
    shortLabel: "Easy Reader",
    description: "Short chapters with illustrations for growing readers",
    ageLabel: "Ages 5-8",
  },
  "8-12": {
    label: "Chapter Book",
    shortLabel: "Chapter Book",
    description: "Longer stories with chapters for confident readers",
    ageLabel: "Ages 8-12",
  },
};

/**
 * Get book type label from age range
 */
export function getBookTypeLabel(ageRange: AgeRange | string): string {
  return BOOK_TYPES[ageRange as AgeRange]?.label || ageRange;
}

/**
 * Get book type short label from age range
 */
export function getBookTypeShortLabel(ageRange: AgeRange | string): string {
  return BOOK_TYPES[ageRange as AgeRange]?.shortLabel || ageRange;
}

/**
 * Get full book type info from age range
 */
export function getBookTypeInfo(ageRange: AgeRange | string): BookTypeInfo {
  return (
    BOOK_TYPES[ageRange as AgeRange] || {
      label: ageRange,
      shortLabel: ageRange,
      description: "",
      ageLabel: ageRange,
    }
  );
}
